import React from 'react';
import { buildClassNames } from '@frontend/jetlend-web-ui/src/utils/classNameUtils';
import styles from './FeatureContentBlock.module.scss';
import Image from '@app/components/Image/Image';
import { IFeatureContentBlockApiModel } from '@app/models/common/common';

export type FeatureContentBlockType = 'white' | 'gray'

interface IProps extends IFeatureContentBlockApiModel{
	/**
	 * Вариант блока
	 */
	variant: FeatureContentBlockType;
}

/**
 * Блока фича контента
 */
export default function FeatureContentBlock({
    variant,
    title,
    description,
    image,
}: IProps) {
    return (
        <div className={buildClassNames(styles, ['container', variant])} >
            <div className={styles['image']}>
                <Image
                    src={image}
                    alt=""
                    fill
                />
            </div>
            <div className={styles['content']}>
                <div className={styles['title']}>{title}</div>
                <div className={styles['description']}>{description}</div>
            </div>
        </div>
    );
};
